import { render, staticRenderFns } from "./CollectTargetPrice.vue?vue&type=template&id=e7780990&scoped=true&"
import script from "./CollectTargetPrice.vue?vue&type=script&lang=js&"
export * from "./CollectTargetPrice.vue?vue&type=script&lang=js&"
import style0 from "./CollectTargetPrice.vue?vue&type=style&index=0&id=e7780990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7780990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VAvatar,VCol,VIcon,VTextField})
